$(function () {
  $(".js-sub-img img").on("click", function () {
    // data-media-id値取得
    var v = $(this).attr("alt");
    $(".product__media-toggle").attr("data-media-id", v);
    // メイン画像に切り替えるimgのsrc取得
    img = $(this).attr("src");
    img2 = $(this).attr("srcset");
    // currentクラス付け替え(枠線などを変えたい時に)
    $(".js-sub-img li").removeClass("is-active");
    $(this).parent().addClass("is-active");
    // fadeOutできたらsrc変更してfadeIn
    $(".js-main-img .product__media-item .product__modal-opener .product__media img").fadeOut(0, function () {
      $(".js-main-img .product__media-item .product__modal-opener .product__media img")
        .attr("src", img).attr("srcset", img2).on("load", function () {
          $(this).fadeIn(0);
        });
    });
  });
});
